document.addEventListener('DOMContentLoaded', function () {
	// Verificar si el body tiene la clase 'specialReportsV2'
	if (!document.body.classList.contains('specialReportsV2')) {
			// Ejecutar el código JavaScript solo si el body NO tiene la clase 'specialReportsV2'
			if (document.querySelector('.hamburger')) { 
					const hamburgerButton = document.querySelector(".hamburger");
					const hamburgerMenu = document.querySelector(".mobile-nav");
					const hamburgerMenuText = document.querySelector(".menuText");

					hamburgerButton.onclick = function() {
							this.classList.toggle("is-active");
							hamburgerMenu.classList.toggle("show-menu");
							hamburgerMenuText.classList.toggle("hideTextMenu");
					};
			}
	}
});
